import React from 'react';
import { Row, Col } from 'antd';
import cx from 'classnames';

import { QuestionnaireModel } from 'api/backofficeApiClient';
import { getQuestionnaireField } from 'utils/assignmentUtils';

import styles from './QuestionnaireItem.module.less';

type Props = {
  title: string;
  questionnaireItem?: QuestionnaireModel;
};

export default function QuestionnaireItem(props: Props) {
  const { title, questionnaireItem } = props;
  const questionnaire = getQuestionnaireField(questionnaireItem);
  const { value, comment } = questionnaire;

  return (
    <Row gutter={[2, 2]} className="titled-sheet">
      <Col xs={24} md={12}>
        <div className="title">{title}</div>
        <div>{value}</div>
      </Col>

      <Col xs={24} md={12}>
        <div
          className={cx(styles.title, {
            [styles.noComment]: comment === 'No comment',
          })}
        >
          <span>{comment}</span>
        </div>
      </Col>
    </Row>
  );
}
